// Mirrors src/components/common/SearchBar.tsx — magnifying glass icon +
// borderless input. Caller provides container styling (border/background) if
// it wants the inset look.

import React from 'react'
import {Search} from 'lucide-react'

interface SearchBarProps {
  value: string
  onChange: (text: string) => void
  placeholder?: string
}

// Compact search bar — 40px tall to match the slim look in the
// RescueChamberListScreen and LocationListScreen screenshots. Used inside a
// surface card on every list screen, so the bar itself is borderless.
export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search..',
}) => (
  <div className="flex h-10 flex-1 items-center gap-sm rounded-md px-sm">
    <Search size={16} color="var(--color-textMuted)" />
    <input
      type="text"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      className="h-full flex-1 bg-transparent p-0 text-md text-textPrimary placeholder-textMuted outline-none"
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
    />
  </div>
)
